export function OrgStatusBadge({ status }: { status: string }) {
  const active = status === 'active';
  const label = active ? 'Active' : status.charAt(0).toUpperCase() + status.slice(1);
  return (
    <span
      className={
        'inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium ' +
        (active ? 'bg-[#f0fdf4] text-[#16a34a]' : 'bg-[#f3f4f6] text-[#6b7280]')
      }
    >
      <span className={'h-1.5 w-1.5 rounded-full ' + (active ? 'bg-[#22c55e]' : 'bg-[#9ca3af]')} />
      {label}
    </span>
  );
}
